'use strict';

angular.module('TurneroApp').service('portal', [
    '$sessionStorage', 'usuarioInfo', 'TurneroAppConstant', '$rootScope',
    function ($sessionStorage, usuarioInfo, TurneroAppConstant, $rootScope) {

    this.getUrlServer = function () {
        
        return $rootScope.urlHostServer;
    };

    this.getHeadersServer = function () {
        return {

        };
    };
}]);


// WEBPACK FOOTER //
// ./app/components/general/portal-service.js